// extracted by mini-css-extract-plugin
export default {"expandIcon":"Collapse_expandIcon__2WWcX"};